import React from 'react'
import Errors from '../../../Errors/Errors'
import DataSourceDetails from './DataSourceDetails'
import UploadGroupBuilder from '../../../UploadGroupBuilder/UploadGroupBuilder'
import I18n from 'i18n-js'

export default class DataSourceBuilderGeneral extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    if(this.props.activeTab === 'general'){
      return (
        <div>
          <Errors errors={this.props.errors} />
          <DataSourceDetails {...this.props} />
          {
            this.props.data_source.system_data
            ?
            null
            :
            <div className="row">
              <div className="col-md-12">
                  <UploadGroupBuilder upload_type="csv" upload_type_plural="csvs" upload_groups={this.props.data_source.file_upload_group && this.props.data_source.new_record ? [this.props.data_source.file_upload_group] : this.props.data_source.file_upload_group && this.props.data_source.file_upload_group.file_uploads ? [{ csvs: this.props.data_source.file_upload_group.file_uploads }] :  [{ csvs: [] }] } onChange={this.props.onChangeFileUploadGroup} data_table_path={this.props.csvs_data_table_path} multiple={false} read_only={this.props.read_only} helperText={"csvs_helper_text"}/>
              </div>
            </div>
          }
        </div>
      );
    } else {return null};
  };

};